var map = {
	"./ad-int.png": 2892,
	"./ad-mar.png": 1602,
	"./adf-n.png": 8433,
	"./adf-sur.png": 4009,
	"./ampip.png": 3627,
	"./cas-m.png": 6925,
	"./cas-p.png": 1782,
	"./com-g.png": 9934,
	"./com-m.png": 1675,
	"./com-p.png": 4764,
	"./icono-empty2.png": 6295,
	"./parcial.png": 4940,
	"./rob-17.png": 9178,
	"./rob-18.png": 7957,
	"./rob-19.png": 3459,
	"./rob-20.png": 1945,
	"./sct.png": 9170,
	"./sin-afectacion.png": 6814,
	"./totalmente.png": 9504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2527;